export default "__VITE_ASSET__Db6LZqYb__"